export class NumberUtils {
  public static roundNumber(num: number, decimalDigit = 1): number {
    let tenFactor = 1;
    for (let i = 0; i < decimalDigit; i += 1) {
      tenFactor *= 10;
    }

    return Math.round(num * tenFactor) / tenFactor;
  }

  public static isNumber(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    return typeof value === 'number';
  }

  public static isPositiveOrZeroNumber(value: any): boolean {
    if (!NumberUtils.isNumber(value)) {
      return false;
    }

    return value >= 0;
  }

  public static isContainDecimal(num: number): boolean {
    return Math.abs(num - Math.round(num)) > 0;
  }

  public static isSameDecimalNumber(num1: number, num2: number): boolean {
    const maxDiff = 0.0000001;

    return Math.abs(num1 - num2) <= maxDiff;
  }

  public static roundArrayOfFloatToIntegerWithSumTarget(orig, target) {
    // src: https://stackoverflow.com/questions/13483430/how-to-make-rounded-percentages-add-up-to-100
    /*
    ( [16.666, 16.666, 16.666, 16.666, 16.666, 16.666], 100)    => [16, 16, 17, 17, 17, 17]
    ( [33.333, 33.333, 33.333]                        , 100)    => [34, 33, 33]
    ( [33.3, 33.3, 33.3, 0.1]                         , 100)    => [34, 33, 33, 0]
    ( [13.25, 47.25, 11.25, 28.25]                    , 100)    => [13, 48, 11, 28]
    ( [25.5, 25.5, 25.5, 23.5]                        , 100)    => [25, 25, 26, 24]
    */

    const errorFactor = (oldNum, newNum) => {
      return Math.abs(oldNum - newNum) / oldNum;
    };

    var i = orig.length,
      j = 0,
      total = 0,
      change,
      newVals = [],
      next,
      factor1,
      factor2,
      len = orig.length,
      marginOfErrors = [];

    // map original values to new array
    while (i--) {
      total += newVals[i] = Math.round(orig[i]);
    }

    change = total < target ? 1 : -1;

    while (total !== target) {
      // Iterate through values and select the one that once changed will introduce
      // the least margin of error in terms of itself. e.g. Incrementing 10 by 1
      // would mean an error of 10% in relation to the value itself.
      for (i = 0; i < len; i++) {
        next = i === len - 1 ? 0 : i + 1;

        factor2 = errorFactor(orig[next], newVals[next] + change);
        factor1 = errorFactor(orig[i], newVals[i] + change);

        if (factor1 > factor2) {
          j = next;
        }
      }

      newVals[j] += change;
      total += change;
    }

    for (i = 0; i < len; i++) {
      marginOfErrors[i] =
        newVals[i] && Math.abs(orig[i] - newVals[i]) / orig[i];
    }

    // Math.round() causes some problems as it is difficult to know at the beginning
    // whether numbers should have been rounded up or down to reduce total margin of error.
    // This section of code increments and decrements values by 1 to find the number
    // combination with least margin of error.
    for (i = 0; i < len; i++) {
      for (j = 0; j < len; j++) {
        if (j === i) continue;

        var roundUpFactor =
          errorFactor(orig[i], newVals[i] + 1) +
          errorFactor(orig[j], newVals[j] - 1);
        var roundDownFactor =
          errorFactor(orig[i], newVals[i] - 1) +
          errorFactor(orig[j], newVals[j] + 1);
        var sumMargin = marginOfErrors[i] + marginOfErrors[j];

        if (roundUpFactor < sumMargin) {
          newVals[i] = newVals[i] + 1;
          newVals[j] = newVals[j] - 1;
          marginOfErrors[i] =
            newVals[i] && Math.abs(orig[i] - newVals[i]) / orig[i];
          marginOfErrors[j] =
            newVals[j] && Math.abs(orig[j] - newVals[j]) / orig[j];
        }

        if (roundDownFactor < sumMargin) {
          newVals[i] = newVals[i] - 1;
          newVals[j] = newVals[j] + 1;
          marginOfErrors[i] =
            newVals[i] && Math.abs(orig[i] - newVals[i]) / orig[i];
          marginOfErrors[j] =
            newVals[j] && Math.abs(orig[j] - newVals[j]) / orig[j];
        }
      }
    }
    return newVals;
  }
}
